<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid ref='gridp' :dataSource='productData' :allowFiltering='true' 
                          :allowPaging='true' 
                          :allowResizing='true' 
                          :allowReordering='true' 
                          :allowSorting='true' 
                          :toolbar='toolbar' 
                          :editSettings='editSettings' 
                          :pageSettings='pageSettings' 
                          :filterSettings='filterOptions' 
                          :toolbarClick='toolbarClick' 
                          :allowExcelExport='true'
                          :actionBegin ='actionBegin'
                          :actionComplete ='actionComplete'
                          :actionFailure ='actionFailure'
                          :enablePersistence ="true"
                          :excelExportComplete='excelExportComplete'>
                    <e-columns>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='name' headerText='Name' :validationRules="requiredRules" width=120></e-column>
                        <e-column field='utilityTypeId' headerText='Commodity' :validationRules="requiredRules" width=120 :edit='utilitiesParams' foreignKeyField='utilityTypeId' foreignKeyValue='utilityTypeName' :dataSource='utilities' editType='dropdownedit'></e-column>
                        <e-column field='tradable' headerText='Tradable' width=120 displayAsCheckBox='true' editType='booleanedit' type='boolean'></e-column>
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { mapState, mapActions } from 'vuex'
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { createElement } from '@syncfusion/ej2-base';
    import { DataManager, WebApiAdaptor, ODataV4Adaptor } from "@syncfusion/ej2-data";
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import axios from 'axios';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let dpUtilities, elUtilities;

    export default {
        name: 'Product',
        data() {
            return {
                store: store,
                productData: SyncHelper.getDataManager("product"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true, showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowDeleting: false,
                    mode: 'Dialog'
                },
                requiredRules: { required: true },
                toolbar: ['Add', 'Delete', 'ExcelExport'],
                utilities: SyncHelper.getDataManager("utils/utilities"),
                utilitiesParams: {
                    create: () => {
                        elUtilities = document.createElement('input');
                        return elUtilities;
                    },
                    read: () => {
                        return dpUtilities.value;
                    },
                    destroy: () => {
                        dpUtilities.destroy();
                    },
                    write: (args) => {
                        dpUtilities = new DropDownList({
                            dataSource: this.utilities,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Comodity',
                            floatLabelType: 'Always'
                        });
                        dpUtilities.appendTo(elUtilities);
                    }
                },
                filterOptions: gridOptions.filterSettings,
            }
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Product.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridp.hideSpinner();
            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.gridp.getColumns().length; i++) {

                    }
                    gridOptions.actionBegin(args);
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>
